module.exports = __webpack_public_path__ + "media/featured_scholarships/fastwebs-featured-scholarships_300x150-b3e87c8c.gif";